import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    root: {
      borderRadius: 8,
      padding: [4, 16],

      '&:hover': {
        backgroundColor: 'var(--x-bg-5)',

        '& $text': {
          color: '#000',
        },
      },
    },

    minWidth: {
      minWidth: 228,
    },

    container: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
    },

    text: {
      color: 'var(--x-breadcrumb-last)',
      fontSize: 14,
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: '32px',
    },

    icon: {
      fill: 'var(--x-textf-field-color-1)',
      height: 16,
      width: 16,
    },
  },
  { name: 'NavSubmenuItem' },
);
